import {ApolloClient, createHttpLink, from} from '@apollo/client';
import {setContext} from '@apollo/client/link/context';
import {ErrorLink, onError} from '@apollo/client/link/error';
import {RetryLink} from '@apollo/client/link/retry';

import {getPersistentTokenValue, PersistentTokenName} from '#hook/usePersistentToken';

import {cache} from './cache';

const httpLink = createHttpLink({
  uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
});

const retryLink = new RetryLink({
  delay: {
    initial: 1000,
    max: Infinity,
    jitter: true,
  },
  attempts: {
    max: 3,
    retryIf: (error, _operation) => !!error,
  },
});

const authLink = setContext(async (_, {headers}) => {
  const token = await getPersistentTokenValue(PersistentTokenName.AuthenticationToken);

  return {
    headers: {
      ...headers,
      ...(token ? {Authorization: `Bearer ${token}`} : {}),
    },
  };
});

export const createClient = ({errorHandler}: {errorHandler: ErrorLink.ErrorHandler}) => {
  const errorLink = onError(errorHandler);

  return new ApolloClient({
    link: from([authLink, errorLink, retryLink, httpLink]),
    cache,
  });
};
